import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgHeadphonesIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
    >
      <path d="M8 48V32a24 24 0 0 1 48 0v16" />
      <path d="M56 50.667A5.333 5.333 0 0 1 50.667 56H48a5.333 5.333 0 0 1-5.333-5.333v-8A5.333 5.333 0 0 1 48 37.333h8zm-48 0A5.333 5.333 0 0 0 13.333 56H16a5.333 5.333 0 0 0 5.333-5.333v-8A5.333 5.333 0 0 0 16 37.333H8z" />
    </g>
  </svg>
)
export default SvgHeadphonesIcon
